import { TALROO } from '@/types/channels';

/** Same rule as the Hire API: a started, non-completed Talroo campaign cannot change its end date. */
export function isTalrooEndDateLocked({
  channelSlug,
  isScheduled,
  isCompleted,
}: {
  channelSlug: string | undefined;
  isScheduled: boolean;
  isCompleted: boolean;
}): boolean {
  return channelSlug === TALROO && !isScheduled && !isCompleted;
}
